<template>
    <Form style="line-height:32px" :model="formdata" :label-width="120" inline>
        <FormItem label='取消原因' style="width:90%" >
            <Input v-model="formdata.cancelCause" :rows="3" type="textarea"/>
        </FormItem>
        <footer class="text-right">
             <Button type="primary" @click="submit">确定</Button>
             <Button @click="cancel">取消</Button>
        </footer>
        <Spin size="large" fix v-if="loading"></Spin>
    </Form>
</template>
<script>
import { HttpTransferStatus } from '@/service/allotment/transfer'
export default {
    props:['activeids','status'],
    data(){
        return {
            loading:false,
            formdata:{
                cancelCause:"",    
            },  
        }
    },
    methods:{
        cancel() {
            this.$emit('on-close')
        },
        async submit(){
            this.loading = true;
            HttpTransferStatus({
                ids:this.activeids,
                status: this.status,
                cancelReason:this.formdata.cancelCause
            }).then(res => {
                this.$VMessage.success(res.message);
                this.cancel();
                this.$emit('on-update');
            },err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(() => {
                this.loading = false;
            })
            
        }
    }
}
</script>
